export const capitalizeFirstLetter = (str: string) => {
  return `${(str ?? "").charAt(0).toLocaleUpperCase()}${(str ?? "").slice(1)}`;
};
